<template>
  <v-container class="container-special-infoCotacao ma-0 pa-0">
    <div v-if="passo == 1">
      <v-form
        ref="infoCotacao"
        class="infoCotacao"
        v-model="valid"
        @submit.prevent="verificarDataParcelas"
      >
        <v-card>
          <v-toolbar height="56" color="primary">
            <v-toolbar-title
              style="padding-left: 10px"
              class="subheading white--text"
            >
              Infos. Gerais
            </v-toolbar-title>
          </v-toolbar>

          <v-container class="px-4">
            <v-layout v-if="camposDisabled" row wrap>
              <v-flex xs12 sm12 md3 pr-2 text-xs-left>
                <v-card
                  style="border: 1px solid #BABABA; border-radius: 5px;"
                  flat
                >
                  <v-card-text style="padding: 5px 10px; margin: 0;">
                    <b
                      >Proposta Auto-Frota
                      {{ retirarNull(apoliceNumeroProposta) }}</b
                    >
                    <br />
                    <v-layout align-center>
                      <v-flex
                        xs7
                        style="padding-top: -5px; margin-top: -5px;"
                      ></v-flex>
                      <v-flex
                        text-xs-right
                        xs5
                        style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;"
                      >
                        <v-tooltip bottom color="blue darken-1">
                          <v-btn
                            :disabled="desabilitaBotaoProposta"
                            style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;"
                            slot="activator"
                            icon
                            color="transparent"
                            @click.native="gerarProposta"
                          >
                            <v-icon text-xs-right color="#00456e"
                              >get_app</v-icon
                            >
                          </v-btn>
                          <div style="text-align: center;">Download</div>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md3 pr-2 text-xs-left>
                <v-card
                  style="border: 1px solid #BABABA; border-radius: 5px;"
                  flat
                >
                  <v-card-text style="padding: 5px 10px; margin: 0;">
                    <b>Apólice Auto-Frota {{ retirarNull(apoliceNumero) }}</b>
                    <br />
                    <v-layout align-center>
                      <v-flex
                        xs7
                        style="padding-top: -5px; margin-top: -5px;"
                      ></v-flex>
                      <v-flex
                        text-xs-right
                        xs5
                        style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;"
                      >
                        <v-tooltip bottom color="blue darken-1">
                          <v-btn
                            :disabled="desabilitaBotaoApolice"
                            style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;"
                            slot="activator"
                            icon
                            color="transparent"
                            @click.native="gerarApolice"
                          >
                            <v-icon text-xs-right color="#00456e"
                              >get_app</v-icon
                            >
                          </v-btn>
                          <div style="text-align: center;">Download</div>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs12 sm12 md3 pr-2 text-xs-left>
                <v-card
                  style="border: 1px solid #BABABA; border-radius: 5px;"
                  flat
                >
                  <v-card-text style="padding: 5px 10px; margin: 0;">
                    <b
                      >Boleto Auto-Frota
                      {{ retirarNull(apoliceNumeroProposta) }}</b
                    >
                    <br />
                    <v-layout align-center>
                      <v-flex xs7 style="padding-top: -5px; margin-top: -5px;">
                      </v-flex>
                      <v-flex
                        text-xs-right
                        xs5
                        style="padding-top: -15px; margin-top: -5px; padding: 0px; margin: 0px;"
                      >
                        <v-tooltip bottom color="blue darken-1">
                          <v-btn
                            :disabled="desabilitaBoletoApolice"
                            style="padding: -20px 0px 0px 0px; margin: -10px 0px 0px 0px;"
                            slot="activator"
                            icon
                            color="transparent"
                            @click.native="gerarBoleto"
                          >
                            <v-icon text-xs-right color="#00456e"
                              >get_app</v-icon
                            >
                          </v-btn>
                          <div style="text-align: center;">Download</div>
                        </v-tooltip>
                      </v-flex>
                    </v-layout>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            <v-flex class="py-4"> Histórico da Proposta </v-flex>
            <v-layout wrap row>
              <v-flex xs12 sm5 md3>
                <v-select
                  label="Tipo"
                  :items="propostaTipoList"
                  v-model="idPropostaTipo"
                  item-text="titulo"
                  :disabled="camposDisabled"
                  item-value="id"
                  required
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm5 md3>
                <v-select
                  label="Tipo Seguro"
                  :items="apoliceTipoDePropostaList"
                  v-model="idTipoDeProposta"
                  :disabled="camposDisabled"
                  item-text="titulo"
                  item-value="id"
                  disabled
                  required
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm5 md3>
                <v-select
                  disabled
                  label="Status"
                  :items="propostaStatusList"
                  v-model="idPropostaStatus"
                  item-text="titulo"
                  item-value="id"
                >
                </v-select>
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex xs12 sm12 md3>
                <v-menu
                  ref="menu"
                  v-model="menu3"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  disabled
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="textAtualizacao"
                      label="Data da Ultima Atualização"
                      prepend-icon="event"
                      readonly
                      disabled
                      v-on="on"
                    ></v-text-field>
                  </template>

                  <v-date-picker
                    v-model="dateInicio"
                    no-title
                    scrollable
                    :disabled="camposDisabled"
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="px-4">
            <v-flex class="py-4"> Proponente </v-flex>
            <v-layout row wrap>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  label="Razão Social"
                  required
                  disabled
                  browser-autocomplete="off"
                  :rules="regras.notNull"
                  v-model="proponenteRazaoSocial"
                >
                </v-text-field>
              </v-flex>
              <v-flex md4>
                <v-select
                  label="Tipo Pessoa"
                  item-text="titulo"
                  item-value="id"
                  disabled
                  v-model="idTipoPessoa"
                  :items="tipoPessoaList"
                  required
                >
                </v-select>
              </v-flex>
              <v-flex md4>
                <v-text-field
                  browser-autocomplete="off"
                  :mask="
                    this.idTipoPessoa === 1
                      ? '###.###.###-##'
                      : 'NN.NNN.NNN/NNNN-##'
                  "
                  :rules="regrasCnpjCpf"
                  :label="{ 1: 'CPF', 2: 'CNPJ' }[idTipoPessoa] || 'CPF/CNPJ'"
                  required
                  disabled
                  v-model="proponenteCnpj"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-text-field
                  mask="##.###-###"
                  label="CEP Pernoite"
                  required
                  :disabled="camposDisabled"
                  browser-autocomplete="off"
                  v-model="cepPernoite"
                  :rules="[...regras.notNull, ...regras.cep]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm12 md6>
                <v-select
                  :items="proponenteRamoDeAtuacaoList"
                  v-model="idProponenteRamoDeAtuacao"
                  label="Ramo de Atuação"
                  item-text="titulo"
                  :disabled="camposDisabled"
                  item-value="id"
                  required
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
            </v-layout>
            <v-layout v-show="idTipoPessoa == 1" row wrap pb-4>
              <v-flex xs12 sm4 md2>
                <v-radio-group
                  :disabled="camposDisabled"
                  row
                  label="Possui Nome Social"
                  v-model="informarNomeSocial"
                >
                  <div class="wrapper-radio-social">
                    <v-radio label="Sim" :value="true"></v-radio>
                    <v-radio label="Não" :value="false"></v-radio>
                  </div>
                </v-radio-group>
              </v-flex>
              <v-flex xs12 sm4 md2 style="align-items:center">
                <v-text-field
                  label="Nome Social"
                  :rules="informarNomeSocial ? regras.nomeSocial : []"
                  v-model="nomeSocial"
                  :disabled="!informarNomeSocial || camposDisabled"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md2> </v-flex>
            </v-layout>
            <v-layout row wrap> </v-layout>
            <v-flex class="py-4"> Endereço </v-flex>
            <v-layout row wrap pb-4>
              <v-flex xs12 sm4 md3>
                <v-text-field
                  mask="##.###-###"
                  :disabled="camposDisabled"
                  label="CEP"
                  required
                  browser-autocomplete="off"
                  v-model="enderecoCep"
                  :rules="[...regras.notNull, ...regras.cep]"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-text-field
                  label="Rua"
                  browser-autocomplete="off"
                  :disabled="camposDisabled"
                  required
                  v-model="enderecoRua"
                  :rules="regras.notNull"
                >
                </v-text-field>
              </v-flex>

              <v-flex xs12 sm2 md1>
                <v-text-field
                  label="Número"
                  browser-autocomplete="off"
                  :disabled="camposDisabled"
                  required
                  :rules="regras.notNull"
                  v-model="enderecoNumero"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md1>
                <v-text-field
                  label="Complemento"
                  browser-autocomplete="off"
                  :disabled="camposDisabled"
                  required
                  :rules="regras.notNull"
                  v-model="enderecoComplemento"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md3>
                <v-text-field
                  label="Bairro"
                  browser-autocomplete="off"
                  :disabled="camposDisabled"
                  riquered
                  :rules="regras.notNull"
                  v-model="enderecoBairro"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm2 md2>
                <v-select
                  label="UF"
                  browser-autocomplete="off"
                  riquered
                  item-text="titulo"
                  item-value="id"
                  :disabled="camposDisabled"
                  :items="enderecoUfList"
                  v-model="idEnderecoUf"
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm2 md4>
                <v-text-field
                  label="Cidade"
                  browser-autocomplete="off"
                  riquered
                  :disabled="camposDisabled"
                  :rules="
                    formRulesComputed.endereco.cidade(enderecoCidade, true)
                  "
                  v-model="enderecoCidade"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md3>
                <v-text-field
                  mask="(##) #####-####"
                  label="Telefone (com DDD)"
                  :disabled="camposDisabled"
                  browser-autocomplete="off"
                  riquered
                  :rules="
                    formRulesComputed.telefone.numero(enderecoTelefone, true)
                  "
                  v-model="enderecoTelefone"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md3>
                <v-text-field
                  label="Email"
                  browser-autocomplete="off"
                  riquered
                  :rules="[...regras.notNull, ...regras.email]"
                  :disabled="camposDisabled"
                  v-model="enderecoEmail"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="px-4">
            <v-flex class="py-4"> Apólice</v-flex>
            <v-layout row wrap pb-4>
              <v-flex xs12 sm2 md3>
                <v-text-field
                  disabled
                  v-model="apoliceNumeroCotacao"
                  label="N. da Cotação"
                  required
                >
                </v-text-field>
              </v-flex>
              <v-flex
                xs12
                sm2
                md3
                v-if="
                  apoliceNumeroProposta === null ||
                    apoliceNumeroProposta === 'null'
                "
              >
                <v-text-field disabled label="N. da Proposta"> </v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md3 v-else>
                <v-text-field
                  disabled
                  v-model="apoliceNumeroProposta"
                  label="N. da Proposta"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-menu
                  ref="menu"
                  v-model="menu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="textInicio"
                      label="Inicio da Vigência"
                      prepend-icon="event"
                      readonly
                      :disabled="camposDisabled"
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dateInicio"
                    @change="onDateChange"
                    no-title
                    :disabled="camposDisabled"
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm4 md3>
                <v-menu
                  ref="menu"
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="textFim"
                      label="Fim da Vigência"
                      :disabled="camposDisabled"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker v-model="dateFim" no-title scrollable>
                  </v-date-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  label="Qtd. de Itens"
                  required
                  v-model="quantidadeItens"
                  disabled
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm3 md4>
                <v-select
                  :items="apoliceModalidadeList"
                  label="Modalidade"
                  v-model="idApoliceModalidade"
                  item-text="titulo"
                  :disabled="camposDisabled"
                  item-value="id"
                  required
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm2 md2>
                <v-text-field
                  type="number"
                  :disabled="camposDisabled"
                  v-model="apoliceIof"
                  label="IOF (%)"
                  required
                  :rules="regras.notNull"
                >
                </v-text-field>
              </v-flex>
              <v-flex xs12 sm2 md4>
                <v-text-field
                  type="number"
                  label="Perc. de Sinistros"
                  v-model="apolicePercSinistro"
                  :disabled="camposDisabled"
                  required
                  :rules="regras.notNull"
                >
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-container class="px-4">
            <v-flex class="py-4"> Valores </v-flex>
            <v-layout row wrap>
              <v-flex xs12 sm3 md4>
                <v-text-field
                  type="number"
                  label="Comissão (%)"
                  :disabled="camposDisabled"
                  v-model="corretagem"
                  required
                  :rules="regras.notNull"
                >
                </v-text-field>
              </v-flex>
              <v-flex>
                <v-btn
                  class="button-custom"
                  @click="dialogParticipantes = true"
                  flat
                >
                  participantes
                </v-btn>
              </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
            <v-layout row wrap>
              <v-flex xs12 sm4 md4>
                <v-menu
                  ref="menu"
                  v-model="menu4"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="textPrimeiraParcela"
                      label="Data da Primeira Parcela"
                      prepend-icon="event"
                      readonly
                      v-on="on"
                      :disabled="camposDisabled"
                      required
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="dataPrimeiraParcela"
                    no-title
                    :disabled="camposDisabled"
                    scrollable
                  >
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs12 sm3 md4>
                <v-select
                  label="Qtd. de parcelas"
                  :items="parcelamentoList"
                  v-model="idParcelamento"
                  item-text="titulo"
                  :disabled="camposDisabled"
                  item-value="id"
                  required
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
              <v-flex xs12 sm7 md4>
                <v-select
                  :items="formaPagamentoList"
                  v-model="idFormaPagamento"
                  label="Forma de Pagamento"
                  item-text="titulo"
                  item-value="id"
                  :disabled="camposDisabled"
                  required
                  :rules="regras.notNull"
                >
                </v-select>
              </v-flex>
            </v-layout>
          </v-container>
          <v-divider></v-divider>
          <v-card-actions style="background-color: #f2f2f2">
            <v-layout
              row
              class="d-flex pa-3"
              style="justify-content: space-between"
            >
              <v-flex md2>
                <v-btn flat style="width: 100%;color: #00456e" @click="voltar">
                  Voltar
                </v-btn>
              </v-flex>
              <v-flex md2>
                <v-btn type="submit" style="width: 86%;" class="primary">
                  Proximo
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
        <template>
          <v-layout row justify-center>
            <v-dialog
              persistent
              v-model="dialogParticipantes"
              max-width="1200px"
            >
              <ModalParticipantes
                v-if="dialogParticipantes"
                :dialog="dialogParticipantes"
                @fechar="dialogParticipantes = false"
                @salvar="salvarParticipantes"
                :participantes="participanteList"
                :somenteLeitura="camposDisabled"
              />
            </v-dialog>
          </v-layout>
        </template>
      </v-form>
    </div>
    <div v-if="passo == 2">
      <ModalRisco
        @proximo="passo = 3"
        :visualizarRisco="visualizarRisco"
        @voltar="passo = 1"
      ></ModalRisco>
    </div>
    <div v-if="passo == 3">
      <ModalGridVeiculos
        @voltarPassoInicio="passo = 1"
        @voltar="passo = 2"
        :visualizarVeiculos="visualizarVeiculos"
        @proximo="passo = 4"
      ></ModalGridVeiculos>
    </div>
    <div v-if="passo == 4">
      <ModalCobertura
        @voltarPassoRisco="passo = 2"
        @voltar="passo = 3"
        @atualizar="atualizarModal"
        @fechar="fechar"
        :visualizarCoberturas="visualizarCoberturas"
      ></ModalCobertura>
    </div>
    <v-snackbar
      :timeout="3000"
      :color="snackbar.sucesso ? 'success' : 'error'"
      multi-line
      v-model="snackbar.visivel"
    >
      {{ snackbar.mensagem }}
      <v-btn dark flat @click.native="snackbar.visivel = false">Fechar</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado.js";
import formRules from "@/helpers/form-rules.js";
import { adicionarId } from "@/helpers/url-helper.js";
import CustomFormat from "@/helpers/custom-format";
import moment from "moment";
import propostaStatusEnum from "@/helpers/tipo-proposta-cotacao.js";

import ModalParticipantes from "../frota/ModalParticipantes.vue";
import ModalRisco from "../corretor-reserva/ModalRisco.vue";
import ModalGridVeiculos from "../corretor-reserva/ModalGridVeiculos";
import ModalCobertura from "../corretor-reserva/ModalCoberturas.vue";
import validadores from "@/helpers/validadores";

export default {
  name: "ModalInfoCotacao",
  props: {
    dadosCotacaoReserva: {
      type: Object,
      required: false
    },
    planilhaValida: {
      type: Boolean,
      default: null,
      required: false
    },
    clickVisualizar: {
      type: Boolean,
      default: null,
      required: false
    },
    clickImportar: {
      type: Boolean,
      default: null,
      required: false
    },
    inicioVigencia: {
      type: String,
      required: false
    }
  },
  components: {
    ModalParticipantes,
    ModalRisco,
    ModalGridVeiculos,
    ModalCobertura
  },
  data: () => ({
    informarNomeSocial: false,
    nomeSocial: "",
    desabilitaBotaoProposta: true,
    desabilitaBotaoApolice: true,
    desabilitaBoletoApolice: true,
    valid: false,
    passo: 1,
    dataRespostaApolice: null,
    dataRespostaBoleto: null,
    visualizarRisco: false,
    propostaStatusList: [],
    visualizarCoberturas: false,
    propostaTipoList: [],
    apoliceModalidadeList: [],
    parcelamentoList: [],
    formaPagamentoList: [],
    proponenteRamoDeAtuacaoList: [],
    corretor: {},
    enderecoUfList: [],
    idPropostaStatus: propostaStatusEnum.statusProposta.EM_PROCESSAMENTO,
    idPropostaTipo: null,
    tipoPessoaList: [],
    idTipoDeProposta: null,
    visualizarVeiculos: false,
    apoliceTipoDePropostaList: [],
    idApoliceModalidade: null,
    idApolice: null,
    dataPrimeiraParcela: new Date().toISOString().slice(0, 10),
    idParcelamento: null,
    idFormaPagamento: null,
    proponenteRazaoSocial: null,
    proponenteCnpj: null,
    cepPernoite: null,
    idProponenteRamoDeAtuacao: null,
    enderecoCep: null,
    enderecoRua: null,
    enderecoNumero: null,
    enderecoComplemento: null,
    enderecoBairro: null,
    enderecoCidade: null,
    idEnderecoUf: null,
    enderecoTelefone: null,
    enderecoEmail: null,
    apoliceNumeroProposta: null,
    apoliceNumero: null,
    apoliceNumeroCotacao: null,
    apoliceIof: 7.38,
    apolicePercSinistro: null,
    corretagem: null,
    totalPremio: 0,
    camposDisabled: false,
    valoresQtdParcelas: null,
    tipoCondicao: null,
    percentualCondicao: null,
    dateAtualizacao: new Date().toISOString().slice(0, 10),
    dateInicio: "",
    idTipoPessoa: null,
    dateFim: "",
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    modal: false,
    dialogParticipantes: false,
    tipoPessoaList: [
      { id: 1, titulo: "Física" },
      { id: 2, titulo: "Jurídica" }
    ],
    tipoCondicaoList: [
      { id: 1, titulo: "Nenhuma" },
      { id: 2, titulo: "Agravo" },
      { id: 3, titulo: " Desconto" }
    ],
    participanteList: [
      {
        idTipoPessoa: 2,
        razaoSocial: "Aphicor Corretora e Administradora de Seguros Ltda.",
        cnpjCpf: "34833592000144",
        enderecoEmail: "seguros@aphicor.com.br",
        enderecoTelefone: "5121219000",
        numeroSusep: "202047257",
        idTipoCoCorretagem: 1,
        coCorretagem: 17,
        corretorLider: true
      }
    ],
    snackbar: {
      visivel: false,
      sucesso: false,
      mensagem: ""
    },
    regras: {
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      cnpj: [v => !!String(v).match(/^[A-Za-z0-9]{12}\d{2}$/) || "Valor incorreto"],
      cep: [v => !!String(v).match(/^\d{8}$/) || "CEP incorreto"],
      email: [
        v =>
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          "E-mail inválido"
      ],
      nomeSocial: [
        v => !!v || "Você não pode deixar este campo em branco",
        v =>
          (v && v.length >= 5) || "Nome social deve ter no mínimo 5 caracteres",
        v =>
          (v && v.length <= 150) ||
          "Nome social deve ter no máximo 150 caracteres"
      ]
    }
  }),
  watch: {
    dadosCotacaoReserva(val) {
      this.carregarDadosCotacaoReserva(val);
    },
    clickVisualizar(val) {
      this.camposDisabled = true;
      if (!this.carregarDadosCotacaoReserva(this.dadosCotacaoReserva)) {
        this.setDadosInfosGerais();
      }
      this.visualizarRisco = true;
      this.visualizarCoberturas = true;
      this.visualizarVeiculos = true;
    },
    clickImportar(val) {
      this.setarDadosProponente();
    },
    idTipoPessoa: function() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    informarNomeSocial: function() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    inicioVigencia: {
      immediate: true,
      handler(newVal) {
        let inicio = newVal ? new Date(newVal) : new Date();

        const fim = new Date(inicio);
        fim.setFullYear(fim.getFullYear() + 1);
        this.dateInicio = inicio.toISOString().split("T")[0];
          this.dateFim = fim.toISOString().split("T")[0];
          this.dataPrimeiraParcela = inicio.toISOString().split("T")[0];
      },

    },


  },
  mounted() {
    this.buscaOpcoes();
  },
  computed: {
    regrasCnpjCpf() {
      if (this.idTipoPessoa === 1) {
        return [
          v => !!v || "Você não pode deixar este campo em branco",
          v => !!String(v).match(/^\d{11}$/) || "CPF inválido"
        ];
      }
      return [
        v => !!v || "Você não pode deixar este campo em branco",
        v => validadores.validarCNPJ(v) || "CNPJ inválido"
      ];
    },
    toLocalDateTimeString: function(val) {
      var data = CustomFormat.toLocaleDateTimeString(val);
      return data.slice(0, 10);
    },
    formatDate(data) {
      if (data != null) {
        var formatedDate = moment(data).format("DD/MM/YYYY");
        return formatedDate;
      }
    },
    quantidadeItens() {
      return this.$store.getters["formCorretorReserva/quantidadeItem"];
    },

    percCondicaoComercial: {
      get() {
        switch (this.tipoCondicao) {
          case 1:
            return 0;
          case 2:
            return +this.percentualCondicao;
          case 3:
            return -this.percentualCondicao;
        }
      },
      set(perc) {
        if (typeof perc === "number") {
          if (perc === 0) {
            this.tipoCondicao = this.tipoCondicaoList[0].id;
          } else {
            this.percentualCondicao = Math.abs(perc);
            this.tipoCondicao = this.tipoCondicaoList[perc > 0 ? 1 : 2].id;
          }
        }
      }
    },
    textAtualizacao() {
      return new Date(this.dateAtualizacao).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    textInicio() {
      this.dateInicio = this.inicioVigencia
        ? new Date(this.inicioVigencia)
        : this.dateInicio;
      return new Date(this.dateInicio).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    textFim() {
      const inicio = new Date(this.dateInicio);
      return new Date(
        inicio.getFullYear() + 1,
        inicio.getMonth(),
        inicio.getDate()  + 1
      ).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    textPrimeiraParcela() {
      return new Date(this.dataPrimeiraParcela).toLocaleDateString("pt-BR", {
        timeZone: "UTC",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    formRulesComputed: function() {
      return formRules;
    }
  },
  methods: {
    verificarDataParcelas() {
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/validarDataParcelamento?dataFimPolice=${this.dateFim}&dataInicioParcela=${this.dataPrimeiraParcela}&parcelas=${this.idParcelamento}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response) {
            this.proximaPagina();
          }
        })
        .catch(err => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = err.response.data.message;
        });
    },
    carregarDadosCotacaoReserva(dados) {
      this.corretor = dados || {};
      this.setarDadosProponente();
      const idApolice = this.corretor.idApolice;
      if (idApolice == null || idApolice === true) {
        return false;
      }
      this.buscarApolice(idApolice);
      this.retornarTipoDeProposta();
      this.retornarTipo();
      return true;
    },
    setarDadosProponente() {
      const dados = this.dadosCotacaoReserva || {};
      this.proponenteRazaoSocial = dados.razaoSocial;
      this.idTipoPessoa = dados.idTipoPessoa;
      this.proponenteCnpj = dados.cnpj;
      this.idTipoDeProposta = dados.idPropostaTipo;
    },
    getRespostaEndosso() {
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/buscaRespostaApolice/${this.corretor.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          if (response.data) {
            if (response.data.pdfApolice != null) {
              this.desabilitaBotaoApolice = false;
            }
            if (response.data.pdfBoleto != null) {
              this.desabilitaBoletoApolice = false;
            }
          }
        });
    },
    gerarProposta() {
      return axios({
        url:
          `${process.env.URL_APOLICEMS}/v1/gerarProposta/` +
          this.corretor.idApolice,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Proposta- " + this.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Proposta não localizado";
        });
    },
    gerarBoleto() {
      return axios({
        url:
          `${process.env.URL_APOLICEMS}/v1/gerarBoleto/` +
          this.corretor.idApolice,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Boleto- " + this.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Boleto não localizado";
        });
    },
    gerarApolice() {
      return axios({
        url:
          `${process.env.URL_APOLICEMS}/v1/gerarApolice/` +
          this.corretor.idApolice,
        method: "GET",
        responseType: "blob",
        headers: {
          Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      })
        .then(response => {
          var blob = new Blob([response.data], { type: "application/pdf" });

          var url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Apolice- " + this.proponenteRazaoSocial + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch(error => {
          this.snackbar.visivel = true;
          this.snackbar.sucesso = false;
          this.snackbar.mensagem = "Pdf Apólice não localizado";
        });
    },
    retirarNull(numero) {
      if (numero === null || numero === "null" || numero === undefined) {
        return;
      } else return numero;
    },
    avancarPassoRisco() {
      this.visualizarRisco = !this.visualizarRisco;
      this.passo = 3;
    },
    setDadosInfosGerais() {
      this.$store.commit("startLoading");
      Object.entries(
        this.$store.getters["formCorretorReserva/infoGerais"]
      ).forEach(([key, value]) => {
        if (
          (this[key] instanceof Array &&
            value instanceof Array &&
            !this[key].length) ||
          (value !== null && value !== undefined)
        ) {
          this[key] = value;
        }
      });
      this.$store.commit("endLoading");
    },
    buscarApolice(idApolice) {
      this.$store.commit("startLoading");
      axios
        .get(`${process.env.URL_APOLICEMS}/v1/visualizarApolice/${idApolice}`, {
          headers: {
            Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
          }
        })
        .then(response => {
          this.$store.commit(
            "formCorretorReserva/setDadosApolice",
            typeof response.data === "string"
              ? JSON.parse(response.data)
              : response.data
          );
          this.setDadosInfosGerais();
          if (
            this.idPropostaStatus == 3 ||
            this.idPropostaStatus == 4 ||
            this.idPropostaStatus == 5
          ) {
            this.desabilitaBotaoProposta = false;
          }
          if (this.idPropostaStatus == 4) {
            this.getRespostaEndosso();
          }
        });
      this.$store.commit("endLoading");
    },
    retornarTipoDeProposta() {
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/retornarTipoDeProposta/${this.corretor.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.idTipoDeProposta = response.data;
        });
    },

    retornarTipo() {
      axios
        .get(
          `${process.env.URL_APOLICEMS}/v1/retornarTipoDeApolice/${this.corretor.idApolice}`,
          {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          }
        )
        .then(response => {
          this.idPropostaTipo = response.data;
        });
    },
    voltar() {
      this.$emit("voltar");
      this.resetarModel();
    },
    resetarModel() {
      (this.idPropostaTipo = null),
        (this.idTipoDeProposta = null),
        (this.proponenteRazaoSocial = null),
        (this.proponenteCnpj = null);
      this.cepPernoite = null;
      this.idProponenteRamoDeAtuacao = null;
      this.enderecoCep = null;
      this.enderecoRua = null;
      this.enderecoNumero = null;
      this.enderecoComplemento = null;
      this.enderecoBairro = null;
      this.idEnderecoUf = null;
      this.enderecoCidade = null;
      this.enderecoTelefone = null;
      this.enderecoEmail = null;
      this.idApoliceModalidade = null;
      this.apoliceIof = null;
      this.apolicePercSinistro = null;
      this.corretagem = null;
      this.idParcelamento = null;
      this.idFormaPagamento = null;
      this.informarNomeSocial = false;
      this.nomeSocial = null;
    },

    buscaOpcoes() {
      [
        "propostaStatus",
        "propostaTipo",
        "apoliceTipoDeProposta",
        "apoliceModalidade",
        "parcelamento",
        "formaPagamento",
        "proponenteRamoDeAtuacao",
        "enderecoUf"
      ].forEach(item => {
        axios
          .get(`${process.env.URL_APOLICEMS}/v1/${item}`, {
            headers: {
              Authorization: `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
            }
          })
          .then(response => {
            this[`${item}List`] =
              response.data instanceof Array ? response.data : [];
          })
          .catch(err => {
            console.error(err);
          });
      });
    },

    fechar() {
      this.$emit("fechar");
    },

    proximaPagina: function() {
      if (this.$refs.infoCotacao.validate()) {
        this.$store.commit("formCorretorReserva/setInfoGerais", {
          idPropostaStatus: this.idPropostaStatus,
          idPropostaTipo: this.idPropostaTipo,
          idTipoDeProposta: this.idTipoDeProposta,
          idApoliceModalidade: this.idApoliceModalidade,
          idFormaPagamento: this.idFormaPagamento,
          idParcelamento: this.idParcelamento,
          proponenteRazaoSocial: this.proponenteRazaoSocial,
          proponenteCnpj: this.proponenteCnpj,
          cepPernoite: this.cepPernoite,
          idProponenteRamoDeAtuacao: this.idProponenteRamoDeAtuacao,
          enderecoCep: this.enderecoCep,
          enderecoRua: this.enderecoRua,
          enderecoNumero: this.enderecoNumero,
          enderecoComplemento: this.enderecoComplemento,
          enderecoBairro: this.enderecoBairro,
          idEnderecoUf: this.idEnderecoUf,
          enderecoCidade: this.enderecoCidade,
          enderecoTelefone: this.enderecoTelefone,
          enderecoEmail: this.enderecoEmail,
          apoliceIof: this.apoliceIof,
          apolicePercSinistro: this.apolicePercSinistro,
          corretagem: this.corretagem,
          totalPremio: this.totalPremio,
          dataPrimeiraParcela: this.dataPrimeiraParcela,
          dateInicio: this.dateInicio,
          dateFim: this.dateFim,
          idTipoPessoa: this.dadosCotacaoReserva.idTipoPessoa,
          participanteList: this.participanteList,
          percCondicaoComercial: this.percCondicaoComercial,
          idUsuarioCorretor: usuarioHelper.USUARIO_LOGADO().idUsuario,
          nomeUsuarioCorretor: usuarioHelper.USUARIO_LOGADO().nome,
          nomeSocial: !this.informarNomeSocial ? "" : this.nomeSocial,
          informarNomeSocial: this.informarNomeSocial
        });
        this.passo = 2;
      }
    },

    atualizarModal() {
      this.$emit("atualizar");
      this.passo = 1;
      this.resetarModel();
    },

    onDateChange: function() {
      const self = this;
      const date = self.dateInicio.split("-");
      const ano = parseInt(date[0]) + 1;
      const newDateFim = date.concat(ano + "-" + date[1] + "-" + date[2]);
      this.dateFim = newDateFim[3];
    },
    salvarParticipantes(participanteList) {
      this.participanteList = participanteList;
      this.dialogParticipantes = false;
    }
  }
};
</script>
<style scoped>
.button-message {
  text-transform: capitalize;
  font-weight: 400;
  font-size: 12px;
}
.container-special-infoCotacao {
  max-width: 100% !important;
}
.button-custom {
  width: 100%;
  max-width: 121px;
  text-align: center;
  color: #fff;
  background-color: #00456e;
  border-radius: 2px;
  display: inline-block;
  padding: 9px 12px;
  cursor: pointer;

  font-weight: bold;
}
.infoCotacao .flex {
  padding: 0 10px;
}
.wrapper-radio-social {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/corretor-reserva/ModalInfoCotacao.vue